import React from 'react'

import {
  parseTypography,
  useBrandColor,
  useBrandTypography,
} from '../../../../Designs/blocs/brandResolvers'
import type { IndexedElement } from '../../../../firebase/model/mix'
import { ElementPositioner } from '../ElementPositioner/ElementPositioner'

import './TextElement.scss'

interface TextElementProps {
  element: IndexedElement & { type: 'text' }
}

const TextElement = ({ element }: TextElementProps) => {
  const resolveBrandTypography = useBrandTypography()
  const resolveBrandColor = useBrandColor()

  const parsedTypography = parseTypography(
    resolveBrandTypography(element.typography)
  )

  return (
    <ElementPositioner element={element}>
      <div
        className="text-element"
        style={{
          '--font-size': parsedTypography.size,
          '--padding-top': element.padding.top,
          '--padding-bottom': element.padding.bottom,
          '--padding-left': element.padding.left,
          '--padding-right': element.padding.right,
          color: resolveBrandColor(element.textColor),
          textAlign: element.textAlignment,
        }}
      >
        <span
          style={{
            fontFamily: `${parsedTypography.family}, ${parsedTypography.fallback}`,
            lineHeight: parsedTypography.lineHeight,
            fontWeight: parsedTypography.weight,
            fontStyle: parsedTypography.style,
          }}
        >
          {element.content}
        </span>
      </div>
    </ElementPositioner>
  )
}

export { TextElement }
